<!--
 * @Description: 获取验证码组件
-->
<template>
    <div>
        <van-button
                type="info"
                size="small"
                class="get-code"
                :disabled="disabled"
                @click.stop="sendSms()"
                native-type="button">
            <span v-show="!disabled">获取验证码</span>
            <van-count-down v-if="disabled" :time="mytime" @finish="onFinish()" format="ss 秒"/>
        </van-button>
    </div>
</template>

<script>
    export default {
        props: {
            phone: String
        },
        data() {
            return {
                disabled: false,
                mytime: 60000,
            }
        },
        methods: {
            sendSms() {
                if (this.phone) {
                    this.disabled = true
                    this.mytime = 60000
                    this.$http.post(this.$api.getSmsCode, {
                        mobile: this.phone
                    }).then(res => {
                        if (res.code === "000") {
                            this.$toast("发送成功");
                        } else {
                            this.$toast(res.msg);
                        }
                    })
                } else {
                    this.$toast('请先填写手机号码')
                }
            },
            onFinish() {
                this.disabled = false
            },
        },
    }
</script>

<style>

</style>